interface StepIndicatorProps {
  currentStep: number;
}

const steps = [
  { number: 1, title: '요금제 선택' },
  { number: 2, title: '사진 업로드' },
  { number: 3, title: '고객 정보' },
  { number: 4, title: '스타일 선택' },
  { number: 5, title: '결제' },
];

export default function StepIndicator({ currentStep }: StepIndicatorProps) {
  return (
    <div className="bg-white border-b border-gray-100 py-8">
      <div className="max-w-4xl mx-auto px-6">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <div key={step.number} className="flex items-center flex-1">
              <div className="flex flex-col items-center flex-1">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-medium text-sm transition-all duration-300 ${
                    currentStep >= step.number
                      ? 'bg-[#C9A96E] text-white'
                      : 'bg-gray-200 text-gray-400'
                  }`}
                >
                  {currentStep > step.number ? (
                    <i className="ri-check-line text-lg"></i>
                  ) : (
                    step.number
                  )}
                </div>
                <span
                  className={`mt-2 text-xs font-light whitespace-nowrap ${
                    currentStep >= step.number ? 'text-[#2D2D2D]' : 'text-gray-400'
                  }`}
                >
                  {step.title}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`h-0.5 flex-1 mx-2 transition-all duration-300 ${
                    currentStep > step.number ? 'bg-[#C9A96E]' : 'bg-gray-200'
                  }`}
                ></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}